import React from 'react';
import { Button, Content } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('login.TwoFactorEnroll');
export default function TwoFactorConfirm({
  authenticationData,
  backToMethodSelectVariant,
  confirmationData,
  loading,
  LoadingComponent,
  onBackToMethodSelect,
  onConfirm2FAMethod,
  selectedMethod,
  setConfirmationData
}) {
  const Component = selectedMethod.confirmationComponent;
  return /*#__PURE__*/React.createElement(Content, {
    relative: true
  }, /*#__PURE__*/React.createElement(Content.Area, {
    variant: "twoStepRequiredContent",
    layout: "flex:colM"
  }, /*#__PURE__*/React.createElement(Component, {
    authenticationData: authenticationData,
    confirmationData: confirmationData,
    setConfirmationData: setConfirmationData
  })), /*#__PURE__*/React.createElement(Content.Footer, {
    variant: "twoStepFooter",
    layout: "flex:colM"
  }, /*#__PURE__*/React.createElement(Button, {
    style: {
      flexGrow: 1
    },
    onClick: onConfirm2FAMethod
  }, loading ? /*#__PURE__*/React.createElement(LoadingComponent, null) : t('submit')), /*#__PURE__*/React.createElement(Button, {
    onClick: onBackToMethodSelect,
    variant: backToMethodSelectVariant
  }, t('methodSelect'))));
}